import { c as _c } from "react/compiler-runtime";
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import styles from './search-suggestions.module.scss';
type SearchSuggestionsProps = {
  onSuggestionClick: (title: string) => void;
};

// TODO: get suggestions from BE
const suggestions = [{
  id: '1',
  title: 'Motivate clients through successful storytelling'
}, {
  id: '2',
  title: 'Top of the Table Q&A: Matthew T. Hoesly, CFP, ChFC'
}, {
  id: '3',
  title: 'Top of the Table Q&A: Qun Lin Amanda Goh'
}, {
  id: '4',
  title: 'Using coaching to unleash your true potential'
}, {
  id: '5',
  title: 'Incorporating the role of a paraplanner into your practice'
}, {
  id: '6',
  title: 'Motivating a client to take action'
}, {
  id: '7',
  title: 'Motivate this'
}, {
  id: '8',
  title: 'The 8 proven principles for perfection'
}, {
  id: '9',
  title: 'The international professional paraplanner: Unleash your new super power!'
}];
export const SearchSuggestions = t0 => {
  const $ = _c(5);
  const {
    onSuggestionClick
  } = t0;
  if (true || suggestions.length <= 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p aria-label={`Suggestions: ${suggestions.length}`} aria-live="polite" className={styles.title}>Suggestions</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSuggestionClick) {
    t2 = suggestions.map(t3 => {
      const {
        id,
        title
      } = t3;
      return <Button aria-label={title} className={styles.suggestion} key={id} onClick={() => onSuggestionClick(title)} variant={ButtonVariant.Plain}>{title}</Button>;
    });
    $[1] = onSuggestionClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={styles.wrapper}>{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};